module.exports = __webpack_public_path__ + "img/1kart.907cb43b.svg";